import request from '../../utils/request';

export default () => request('/roles/partyCode');
